/* unplugin-vue-components disabled */import { render } from "./SopForeground.vue?vue&type=template&id=40079d74&scoped=true"
import script from "./SopForeground.vue?vue&type=script&lang=js"
export * from "./SopForeground.vue?vue&type=script&lang=js"

import "./SopForeground.vue?vue&type=style&index=0&id=40079d74&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40079d74"]])

export default __exports__